import isArray from "./component-library251.mjs";
import isKey from "./component-library307.mjs";
import stringToPath from "./component-library313.mjs";
import toString from "./component-library206.mjs";
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}
export {
  castPath as default
};
